import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/home/runner/work/videlio/videlio/apps/frontend/src/layouts/default.vue").then(m => m.default || m)),
  sandbox: defineAsyncComponent(() => import("/home/runner/work/videlio/videlio/apps/frontend/src/layouts/sandbox.vue").then(m => m.default || m))
}